import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../../shared/services/auth/authentication.service';
import { AlertifyService } from '../../shared/services/alertify/alertify.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  const alertifyService = inject(AlertifyService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const currentUrl = router.url;
      let message =
        error.error?.message ??
        error.message ??
        'An unexpected error occurred.';

      switch (error.status) {
        case 0:
          message = 'Failed to reach server';
          // Prevent redirect loop on auth pages
          // if (!currentUrl.match(/^\/(auth)?\/?$/)) router.navigate(['/']);
          break;

        case 401:
          // Prevent redirect loop on auth pages
          // if (!currentUrl.match(/^\/(auth)?\/?$/))

          if (authenticationService.isAuthenticated)
            authenticationService.forceUserOut();
          break;

        case 403:
          alertifyService.error(message);
          // Prevent redirect loop on auth pages
          // if (!currentUrl.match(/^\/(auth)?\/?$/))
          //   authenticationService.forceUserOut();

          if (authenticationService.isAuthenticated)
            authenticationService.forceUserOut();
          break;

        // case 404:
        //   router.navigate(['/not-found']);
        // break;
      }

      return throwError(() => ({ status: error.status, message }));
    }),
  );
};
